// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Calendar = function Calendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.188.938A.935.935 0 0 0 6.25 0a.935.935 0 0 0-.937.938V2.5H3.75A2.5 2.5 0 0 0 1.25 5v12.5c0 1.379 1.121 2.5 2.5 2.5h12.5c1.379 0 2.5-1.121 2.5-2.5V5c0-1.379-1.121-2.5-2.5-2.5h-1.562V.938A.935.935 0 0 0 13.75 0a.935.935 0 0 0-.937.938V2.5H7.187zM3.125 7.5h13.75v10a.627.627 0 0 1-.625.625H3.75a.627.627 0 0 1-.625-.625z"
  }));
};
